module.exports = __webpack_public_path__ + "img/valuationResultData.a9a6ce15.png";